import React, { Component } from "react";
import { TableCell, TableRow } from "@material-ui/core";
import EmptyState from "./EmptyState";

/**
 * Shared empty-state row for tables (used app-wide across ~250 screens).
 *
 * Upgraded (T39 P0 #3) from a bare 300px "data not found" image to the branded
 * <EmptyState>. Also surfaces the `label` prop callers were already passing
 * (e.g. "No Data Found..") — it was previously ignored, so those screens showed
 * only the image. `description` is an optional new prop; behaviour is otherwise
 * backward-compatible (same TableRow/TableCell shape + colSpan).
 */
export default class TableRecordNotFound extends Component {
  render() {
    const { colSpan, label, description } = this.props;
    const cleaned = label ? String(label).replace(/\.+\s*$/, "").trim() : "";
    return (
      <TableRow>
        <TableCell colSpan={colSpan} style={{ borderBottom: "none", padding: 0 }}>
          <EmptyState
            compact
            title={cleaned || "No records found"}
            description={description}
          />
        </TableCell>
      </TableRow>
    );
  }
}
